import { createStore, combineReducers } from "redux";
import { userReducer } from "../Reducer/User.reducer";
import { positionsReducer } from "../Reducer/Positions.reducer";
import { locationsReducer } from "../Reducer/Locations.reducer";

const reducers = combineReducers({ userReducer , positionsReducer, locationsReducer});

export const store = createStore(reducers);
